__turbopack_context__.v({
  "activeBtn": "loker-module__amCCBG__activeBtn",
  "arrow": "loker-module__amCCBG__arrow",
  "articleContainer": "loker-module__amCCBG__articleContainer",
  "articleContent": "loker-module__amCCBG__articleContent",
  "articleDate": "loker-module__amCCBG__articleDate",
  "articleDetail": "loker-module__amCCBG__articleDetail",
  "articleExcerpt": "loker-module__amCCBG__articleExcerpt",
  "articleFooter": "loker-module__amCCBG__articleFooter",
  "articleImageBlock": "loker-module__amCCBG__articleImageBlock",
  "articleMeta": "loker-module__amCCBG__articleMeta",
  "articleTitle": "loker-module__amCCBG__articleTitle",
  "articlesSection": "loker-module__amCCBG__articlesSection",
  "backLink": "loker-module__amCCBG__backLink",
  "breadcrumb": "loker-module__amCCBG__breadcrumb",
  "breadcrumbCurrent": "loker-module__amCCBG__breadcrumbCurrent",
  "breadcrumbLink": "loker-module__amCCBG__breadcrumbLink",
  "breadcrumbSeparator": "loker-module__amCCBG__breadcrumbSeparator",
  "card": "loker-module__amCCBG__card",
  "cardBody": "loker-module__amCCBG__cardBody",
  "cardExcerptModern": "loker-module__amCCBG__cardExcerptModern",
  "cardImage": "loker-module__amCCBG__cardImage",
  "cardMeta": "loker-module__amCCBG__cardMeta",
  "cardTitleModern": "loker-module__amCCBG__cardTitleModern",
  "clearSearch": "loker-module__amCCBG__clearSearch",
  "date": "loker-module__amCCBG__date",
  "dateSmall": "loker-module__amCCBG__dateSmall",
  "detailHeader": "loker-module__amCCBG__detailHeader",
  "emptyState": "loker-module__amCCBG__emptyState",
  "featuredBadge": "loker-module__amCCBG__featuredBadge",
  "featuredCard": "loker-module__amCCBG__featuredCard",
  "featuredContent": "loker-module__amCCBG__featuredContent",
  "featuredExcerpt": "loker-module__amCCBG__featuredExcerpt",
  "featuredImage": "loker-module__amCCBG__featuredImage",
  "featuredSection": "loker-module__amCCBG__featuredSection",
  "featuredTitle": "loker-module__amCCBG__featuredTitle",
  "grid": "loker-module__amCCBG__grid",
  "heroImage": "loker-module__amCCBG__heroImage",
  "heroImageFallback": "loker-module__amCCBG__heroImageFallback",
  "logoFallbackFeatured": "loker-module__amCCBG__logoFallbackFeatured",
  "logoFallbackSmall": "loker-module__amCCBG__logoFallbackSmall",
  "main": "loker-module__amCCBG__main",
  "pageBtn": "loker-module__amCCBG__pageBtn",
  "pageDots": "loker-module__amCCBG__pageDots",
  "pagination": "loker-module__amCCBG__pagination",
  "placeholder": "loker-module__amCCBG__placeholder",
  "readMoreModern": "loker-module__amCCBG__readMoreModern",
  "readMoreSmall": "loker-module__amCCBG__readMoreSmall",
  "relatedSection": "loker-module__amCCBG__relatedSection",
  "relatedTitle": "loker-module__amCCBG__relatedTitle",
  "searchButton": "loker-module__amCCBG__searchButton",
  "searchClear": "loker-module__amCCBG__searchClear",
  "searchForm": "loker-module__amCCBG__searchForm",
  "searchIcon": "loker-module__amCCBG__searchIcon",
  "searchInput": "loker-module__amCCBG__searchInput",
  "searchInputWrapper": "loker-module__amCCBG__searchInputWrapper",
  "searchResultsHeader": "loker-module__amCCBG__searchResultsHeader",
  "seoContent": "loker-module__amCCBG__seoContent",
  "seoText": "loker-module__amCCBG__seoText",
  "shareFacebook": "loker-module__amCCBG__shareFacebook",
  "shareLink": "loker-module__amCCBG__shareLink",
  "shareLinks": "loker-module__amCCBG__shareLinks",
  "shareSection": "loker-module__amCCBG__shareSection",
  "shareWhatsApp": "loker-module__amCCBG__shareWhatsApp",
  "shimmer": "loker-module__amCCBG__shimmer",
  "skeleton": "loker-module__amCCBG__skeleton",
  "skeletonFeatured": "loker-module__amCCBG__skeletonFeatured",
  "skeletonImage": "loker-module__amCCBG__skeletonImage",
  "skeletonText": "loker-module__amCCBG__skeletonText",
  "skeletonTitle": "loker-module__amCCBG__skeletonTitle",
});
